<template>
    <main id="mainCtrl" v-cloak>
        <header class="header-filters changelog-page">
            <!--TODO v-select-period посылает событие 2 раза -->
            <date-range-picker ref="datepicker"
                @selected="setCreatePeriodFilter"
            />

            <v-select v-if="!clinicFilterName"
                      @remove="selectClinic"
                      :options="foundClinics"
                      @search-change="findClinics"
                      placeholder="Поиск клиник...">
                <template v-slot="{ option }">
                    <div class="textarea">
                        <span>{{ option.text }}</span>
                        &nbsp;&nbsp;&nbsp;
                        <span v-if="option.networkName !== null" class="label bg-red">
                            {{ option.networkName }}
                        </span>
                        <br>
                        <small>{{ option.cityName }}, {{ option.address }}</small>
                    </div>
                </template>
            </v-select>

            <v-input v-else v-model="clinicFilterName" class="selectedClinic" disabled style="color: black;"/>

            <select v-cloak v-model="detailLevel" style="float: right" width="45" class="large" @change="detailLevelChange">
                <option value="">S</option>
                <option value="M">M</option>
                <option value="L">L</option>
            </select>
        </header>
        <v-table id="table"
                 request-uri="changelog/getList"
                 pagination-uri="changelog/tableMeta"
                 pagesize="50"
                 ref="table"
                 :lazycount="true"
                 :default-filter="{}"
                 @clear-table-filter="clearPlaceholder"
        >
            <template v-slot:header>
                <v-tr>
                    <v-th name="created_at" title="Дата" sort="created_at" width="90">
                        <span>Дата</span>
                    </v-th>
                    <v-th name="time" title="Время" sort="created_at" width="50">
                        <span>Вр</span>
                    </v-th>
                    <v-th name="action" title="Действие" sort="action" width="70">
                        <span>Дейст</span>
                    </v-th>
                    <v-th name="service" title="Кабинет" sort="service" width="50">
                        <span>Каб</span>
                    </v-th>
                    <v-th name="class" title="Сущность" sort="class" width="60">
                        <span>Сущ</span>
                    </v-th>
                    <v-th name="name" title="Название" sort="name" width="250">
                        <span>Название</span>
                    </v-th>
                    <v-th name="changing" title="Изменения"  minwidth="665">
                        <span>Изменения</span>
                    </v-th>
                    <v-th name="entity_id" title="entity_id" width="110">
                        <span>entity_id</span>
                    </v-th>
                    <v-th name="user_id" title="Кто" sort="user_id" width="50">
                        <span>Кто</span>
                    </v-th>
                    <v-th name="duration" title="Длительность"  sort="duration" width="50">
                        <span>Длит</span>
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="created_at" v-slot="{ filter }" width="90">
                        <date-piker
                            :format="'YYYY-MM-DD'"
                            v-model="filter.value"
                            ref="singleDate"
                            @change="clearDateRangePicker"
                        />
                    </v-th>
                    <v-th name="time" width="50">

                    </v-th>
                    <v-th name="action" v-slot="{ filter }" width="70">
                        <v-select
                            v-model="filter.value"
                            :options="actionOptions"
                        />
                    </v-th>
                    <v-th name="service" v-slot="{ filter }" width="50">
                        <v-select
                            v-model="filter.value"
                            :options="serviceOptions"
                        />
                    </v-th>
                    <v-th name="class" v-slot="{ filter }" width="60">
                        <v-select
                            v-model="filter.value"
                            :options="classOptions"
                        />
                    </v-th>
                    <v-th name="name" :debounce="true" v-slot="{ filter }" width="250">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="changing" v-slot="{ filter }" minwidth="665">
                        <DiffFilter
                            @input="updateTable"
                            :value="diffTitle"
                            :class-filter="isTableLoaded() ? classFilter : ''"
                        />
                    </v-th>
                    <v-th name="entity_id" v-slot="{ filter }" width="110">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="user_id" v-slot="{ filter }" width="50">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: 'DOCTOR_SITE', text: 'Врач' },
                                { value: 'PATIENT', text: 'Пациент' },
                                ...managerOptions
                            ]"
                        />
                    </v-th>
                    <v-th name="duration" v-slot="{ filter }" width="50">
                        <v-input v-model="filter.value"/>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr class="hover" style="cursor: default" :key="item.id">
                    <v-td name="created_at">
                        <span>{{ item.created_at | formatDate }}</span>
                    </v-td>
                    <v-td align="center" name="time">
                        <span>{{ item.created_at | formatTime }}</span>
                    </v-td>
                    <v-td align="center" name="action">
                        <span>{{ actionMap[item.action] }}</span>
                    </v-td>
                    <v-td align="center" name="service">
                        <span>{{ serviceMap[item.service] }}</span>
                    </v-td>
                    <v-td align="center" name="class">
                        <span>{{ classMap[item.class] }}</span>
                    </v-td>
                    <v-td name="name">
                        <span>{{ item.name }}</span>
                    </v-td>
                    <v-td name="changing" minwidth="665">
                        <DetailLevel_S v-if="detailLevel === ''" :diff="item.diff" :rowData="item"/>
                        <DetailLevel_M v-if="detailLevel === 'M'" :diff="item.diff" :rowData="item"/>
                        <DetailLevel_L v-if="detailLevel === 'L'" :diff="item.diff" :rowData="item"/>
                    </v-td>
                    <v-td align="center" name="entity_id" width="110">
                        <span>{{ item.entity_id }}</span>
                    </v-td>
                    <v-td align="center" name="user_id">
                        <span v-if="item.user" v-tooltip="item.user.tooltip">
                            {{ item.user.name }}
                        </span>
                        <span v-else></span>
                    </v-td>
                    <v-td align="right" name="duration">
                        <span>{{ item.duration }}</span>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
    import DetailLevel_S from "./changelog/DetailLevel_S";
    import DetailLevel_M from "./changelog/DetailLevel_M";
    import DetailLevel_L from "./changelog/DetailLevel_L";
    import DiffFilter from "./changelog/DiffFilter";

    export default {
        name: "Changelog",
        components: { DiffFilter, DetailLevel_L, DetailLevel_M, DetailLevel_S },
        filters: {
            formatTime(time) {
                function isDateEmpty(date) {
                    return (
                        (typeof date === 'undefined') ||
                        (date === null) ||
                        (date === '') ||
                        (date === '0000-00-00') ||
                        (date === '0000-00-00 00:00:00')
                        // !moment(date).isValid() // долго
                    );
                }
                if (isDateEmpty(time)) return '';

                if (time.substr(2, 1) === ':') {
                    return time.substr(0, 5);

                } else {
                    return time.substr(11, 5);
                }
            },
        },
        props: {
            managerOptions: { type: Array, required: true },
        },

        data() {
            return {
                detailLevel: localStorage.getItem(window.location.pathname + '@detailLevel') !== null ? localStorage.getItem(window.location.pathname + '@detailLevel') : '',
                actionMap: {
                    UPDATE: 'Ред',
                    CREATE: 'Соз',
                    DELETE: 'Уд',
                    MERGE: 'Об',
                    MODERATE: 'Мод',
                    CANCEL_MODERATE: 'ОтМод',
                    MERGE_MODERATE: 'ОбМод',
                },
                actionOptions: [
                    {
                        value: '',
                        text: 'Без фильтра',
                    },
                    {
                        value: 'UPDATE',
                        text: 'Редактирован',
                    },
                    {
                        value: 'UPDATE_ONLY_FIRE',
                        text: 'Редактирован (только места работы/цены)',
                    },
                    {
                        value: 'CREATE',
                        text: 'Создан',
                    },
                    {
                        value: 'DELETE',
                        text: 'Удалён',
                    },
                    {
                        value: 'MERGE',
                        text: 'Объединён',
                    },
                    {
                        value: 'MERGE, MODERATE, MERGE_MODERATE',
                        text: 'Объединён, Модерирован, Объед&мод',
                    },
                    {
                        value: 'MODERATE',
                        text: 'Модерирован',
                    },
                    {
                        value: 'MERGE, MERGE_MODERATE',
                        text: 'Объединён, Объед&мод',
                    },
                    {
                        value: 'MODERATE, MERGE_MODERATE',
                        text: 'Модерирован, Объед&мод',
                    },
                    {
                        value: 'CANCEL_MODERATE',
                        text: 'Отмена модерации',
                    },
                    {
                        value: 'MERGE_MODERATE',
                        text: 'Объед&мод',
                    },

                ],
                serviceMap: {
                    admin: 'Адм',
                    clinics: 'Кл',
                    network: 'Сеть',
                    site: 'Сайт',
                },
                serviceOptions: [
                    {
                        value: '',
                        text: 'Без фильтра',
                    },
                    {
                        value: 'admin',
                        text: 'Каб. администратора',
                    },
                    {
                        value: 'clinics',
                        text: 'Каб. клиники',
                    },
                    {
                        value: 'network',
                        text: 'Каб. сети',
                    },
                    {
                        value: 'site',
                        text: 'Сайт',
                    },
                ],
                classMap: {
                    DoctorUserPassportDetails: 'Паспорт',
                    DoctorPaymentData: 'Выплаты',
                    Doctor: 'Врач',
                    ConsultQuestion: 'Консульт',
                    ConsultAnswer: 'Ответ',
                    DirectQuestion: 'Вопрос',
                    Review: 'Отз',
                    ReviewComment: 'ОтвОтз',
                    Document: 'Докум',
                    Showcard: 'Реклама',
                    Clinic: 'Клиника',
                    Network: 'Сеть',
                    Service: 'Сервис',
                    Promotion: 'Акция',
                    News: 'Новость',
                    Withdrawal: 'Заявка'
                },
                classOptions: [
                    {
                        value: '',
                        text: '\u00a0',
                    },
                    {
                        value: 'Doctor',
                        text: 'Врач',
                    },
                    {
                        value: 'DirectQuestion',
                        text: 'Вопрос',
                    },
                    {
                        value: 'ConsultQuestion',
                        text: 'Консультация',
                    },
                    {
                        value: 'ConsultAnswer',
                        text: 'Ответ на вопрос',
                    },
                    {
                        value: 'Review',
                        text: 'Отзыв',
                    },
                    {
                        value: 'ReviewComment',
                        text: 'Ответ на отзыв',
                    },
                    {
                        value: 'Document',
                        text: 'Документ',
                    },
                    {
                        value: 'Showcard',
                        text: 'Реклама',
                    },
                    {
                        value: 'Clinic',
                        text: 'Клиника',
                    },
                    {
                        value: 'Network',
                        text: 'Сеть',
                    },
                    {
                        value: 'Service',
                        text: 'Сервис',
                    },
                    {
                        value: 'Promotion',
                        text: 'Акция',
                    },
                    {
                        value: 'News',
                        text: 'Новость',
                    },
                    {
                        value: 'Withdrawal',
                        text: 'Заявка на вывод',
                    },
                  {
                    value: 'DoctorUserPassportDetails',
                    text: 'Паспортные данные',
                  },
                  {
                    value: 'DoctorPaymentData',
                    text: 'Данные по выплатам',
                  },
                ],
                foundClinics: [],
                clinicFilterId: localStorage.getItem(window.location.pathname + '@changelogClinicId') ?? '',
                clinicFilterName: localStorage.getItem(window.location.pathname + '@changelogClinicName') ?? '',
                clinicSearchRequest: null,
            }
        },
        watch: {
          diffTitle: function () {
            this.$refs.changelogtable.update();
          },
          clinicFilterName: function (val) {
            if (!val) {
              this.clinicFilterId = '';

              delete this.$refs.table.$data.filter.clinicId;
              delete this.$refs.table.$data.filter.clinicName;

              localStorage.removeItem(window.location.pathname + '@changelogClinicId');
              localStorage.removeItem(window.location.pathname + '@changelogClinicName');
            } else {
              this.$refs.table.$data.filter.clinicId = this.clinicFilterId;
              this.$refs.table.$data.filter.clinicName = val;

              localStorage.setItem(window.location.pathname + '@changelogClinicId', this.clinicFilterId);
              localStorage.setItem(window.location.pathname + '@changelogClinicName', val);
            }

            this.$refs.table.update();
          }
        },
        computed: {
            classFilter() {
                if (this.isTableLoaded()) {
                    return this.$refs.table.$data.filter.class
                }

                return ''
            },
            diffTitle() {
              if (this.isTableLoaded()) {
                return this.$refs.changelogtable.$data.filter.diffTitle
              }

              return ''
            },
            tableLoaded() {
              return this.isTableLoaded();
            }
        },
        methods: {
            detailLevelChange: function () {
                localStorage.setItem(window.location.pathname + '@detailLevel', this.detailLevel);
            },

            setCreatePeriodFilter(data) {
                if (this.isTableLoaded()) {
                    if (data) {
                        this.$refs.table.$data.filter.createdPeriod = data;
                        if (this.$refs.singleDate) {
                            this.$refs.singleDate.$refs.popup.clear();
                        }
                    } else {
                        delete this.$refs.table.$data.filter.createdPeriod;
                    }
                    this.$refs.table.update();
                }
            },
            isTableLoaded() {
                return this.$refs?.table !== undefined;
            },
            updateTable(data) {
                if (data) {
                    this.$refs.table.$data.filter.diffTitle = data;
                } else {
                    delete this.$refs.table.$data.filter.diffTitle;
                }

                this.$refs.table.update();
            },
            clearPlaceholder() {
                this.$refs.datepicker.clearRange()
                this.clinicFilterName = '';
            },
            clearDateRangePicker() {
                if (this.$refs.singleDate.date && this.$refs.datepicker.end) {
                    delete this.$refs.datepicker.clearRange();
                }
            },
            selectClinic: function (payload) {
                this.foundClinics = [];

                this.clinicFilterId = payload.id;
                this.clinicFilterName = payload.text;
            },
            findClinics: function (query) {
                if (this.clinicSearchRequest) {
                    this.clinicSearchRequest.cancel();
                }
                if (query.length > 2) {
                    this.clinicSearchRequest = this.axios.CancelToken.source();
                    this.axios.post('/clinicsAutocomplete', {
                        q: query,
                        filter: {}
                    }, {
                        cancelToken: this.clinicSearchRequest.token
                    }).then(res => {
                        this.foundClinics = res.data.suggestions.map(item => {
                            return {
                                id: item.data.id,
                                account_id: item.data.account_id,
                                text: item.data.name,
                                cityName: item.data.cityName,
                                networkName: item.data.networkName,
                                address: item.data.address
                            }
                        })
                    })
                } else {
                    this.foundClinics = [];
                }
            },
        },
    }
</script>

<style lang="scss">
    .header-filters.changelog-page {
        display: flex;
        justify-content: space-between;
    }
    .selectedClinic {
        align-items: flex-start;
        width: 100%;

        .clearBut {
            top: 35%
        }
    }
</style>
